import { countCheckPrepaySuccess, countPrepaySuccess, deletePrepaySuccess, payCardPrepaySuccess, savePrepaySuccess, searchPrepaySuccess, setDeletePrepay, setPayCardPreResult } from "@app/actions/myoffice/order/prepay.action";
import { PrepaySearchModel } from "@app/models/myoffice/order/prepay-search.model";
import { ResultProc } from "@app/models/system/result-proc.model";
import { PrepayState } from "@app/selectors/myoffice/order/prepay.selector";
import { createReducer, on } from "@ngrx/store";

export const prepayFeatureKey = "prepay";

export const initialState: PrepayState = {
    resultPayPrepay: {} as ResultProc,
    resultSavePrepay: {} as ResultProc,
    searchItems: [] as PrepaySearchModel[],
    totalItems: 0,
    checkPreItems: 0,
    resultDelete:{} as ResultProc
}

export const prepayReducer = createReducer(
    initialState,
    on(payCardPrepaySuccess, (state, { result }) => ({ ...state, resultPayPrepay: result })),
    on(setPayCardPreResult, (state, { preCardResult }) => ({ ...state, resultPayPrepay: preCardResult })),
    on(savePrepaySuccess, (state, { result }) => ({ ...state, resultSavePrepay: result })),
    on(searchPrepaySuccess, (state, { prepay }) => ({ ...state, searchItems: prepay })),
    on(countPrepaySuccess, (state, { count }) => ({ ...state, totalItems: count })),
    on(countCheckPrepaySuccess, (state, { count }) => ({ ...state, checkPreItems: count })),
    on(deletePrepaySuccess, (state, { result }) => ({ ...state, resultDelete: result })),
    on(setDeletePrepay, (state, { deleteResult }) => ({ ...state, resultDelete: deleteResult })),
);